import React from 'react';
import M from 'materialize-css/dist/js/materialize';
import Select from '../../../../../components/UI/Select';
import BaseComponent from '../../../../../components/BaseComponent';
import { translate } from '../../../../../utils/util';

class ConfirmeModalCallDelivery extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            model: {
                justificationId: '',
            },
            validations: [
            ],
        };
    }

    componentDidMount() {
        this.instance = M.Modal.init(this.modal);
    }

    onConfirm = () => {
        if (this.props.onConfirm) {
            const justification = this.state?.model?.justificationId > 0 ? parseInt(this.state?.model?.justificationId) : undefined;

            if (justification) {
                this.props.onConfirm(justification);
                this.close();
            }
        }
    }

    onCancel = () => {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
        this.close();
    };

    close() {
        if (this.props.onClose) {
            this.props.onClose();
        }
        M.Modal.getInstance(this.modal).close();
    }

    show() {
        this.instance.open();
    }

    render() {
        return (
            <div>
                <div id={this.props.id ? this.props.id : 'confirm-modal'} ref={(modalEl) => this.modal = modalEl} className="modal" style={{ backgroundColor: '#ffffff' }}>
                    <div className="modal-content black-text">
                        <h4>{this.props.data.title}</h4>
                        {translate("delivery:message.confirm-manual-call")}
                    </div>
                    <div className="row" style={{ marginBottom: '0px' }}>
                        <div className="padding col s12">
                            <Select
                                id="justificationId"
                                name="model.justificationId"
                                placeHolder={translate("delivery:fields.justification")}
                                defaultValue={this.state.model.justificationId}
                                place
                                change={(el) => { this.onValueChange(el); }}
                                data={this.props.justifications ? this.props.justifications?.map((i) => { return { id: i.justificationId, text: i.description }; }) : []}
                            />
                        </div>
                    </div>
                    <div className="modal-footer" style={{ backgroundColor: '#ffffff' }}>
                        <div className="row">
                            <button
                                type="button"
                                onClick={this.onCancel}
                                className="col s6 m3 push-m6
                                    btn
                                    btn-flat
                                    waves-effect
                                    waves-light"
                            >
                                {this.props.btnCancel ? this.props.btnCancel : translate('general.cancel')}
                            </button>
                            <button
                                type="button"
                                className="col s6 m3 push-m6
                                btn
                                btn-principal
                                waves-effect
                                waves-light"
                                onClick={this.onConfirm}

                            >
                                {this.props.btnConfirm ? this.props.btnConfirm : translate('general.confirm')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfirmeModalCallDelivery;
